import { create } from 'zustand';

/**
 * 일반 UI 토스트(알림용).
 * 포인트 토스트(pointStore)와 분리 — 여긴 "링크 복사됨", "저장됐어요", 에러 메시지 등 일반 안내.
 */
export type ToastKind = 'info' | 'success' | 'error';

export interface ToastItem {
  id: number;
  message: string;
  kind: ToastKind;
}

interface ToastState {
  toasts: ToastItem[];
  show: (message: string, kind?: ToastKind) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  remove: (id: number) => void;
}

let seq = 0;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  show: (message, kind = 'info') => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { id, message, kind }] }));
    window.setTimeout(() => get().remove(id), 2500);
  },
  success: (message) => get().show(message, 'success'),
  error: (message) => get().show(message, 'error'),
  remove: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** 함수 참조만 필요할 때 훅 없이 호출 (mutation.onSuccess 등) */
export function toast(message: string, kind: ToastKind = 'info') {
  useToastStore.getState().show(message, kind);
}
toast.success = (m: string) => useToastStore.getState().success(m);
toast.error = (m: string) => useToastStore.getState().error(m);
